import _extends from "@babel/runtime/helpers/extends";
import cx from 'classnames';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { propStyling } from '../../shared/propStyling';
import { extractStylingProps } from '../../shared/propStyling/propStylingUtils';
import { tombac } from '../../shared/tombac';
const Append = styled.span.withConfig({
  displayName: "Input__Append"
})(["all:unset;align-items:center;color:", ";cursor:", ";display:flex;padding:", ";padding-top:", ";"], _ref => {
  let {
    invalid,
    variant
  } = _ref;
  return invalid || variant === 'danger' ? tombac.color('danger', 500) : variant === 'alert' ? tombac.color('alert', 600) : 'inherit';
}, _ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled ? 'default' : 'auto';
}, _ref3 => {
  let {
    append
  } = _ref3;
  return !append ? 0 : tombac.space(0, 2, 0, 0);
}, _ref4 => {
  let {
    append
  } = _ref4;
  return typeof append === 'string' ? '0.2em' /* Fixes font alignment */ : undefined;
});
const Container = styled.span.withConfig({
  displayName: "Input__Container"
})(["all:initial;display:inline-flex;position:relative;width:", ";", " ", ""], tombac.space(20), tombac.text({
  fontSize: 14
}), propStyling);
const InputElement = styled.input.withConfig({
  displayName: "Input__InputElement"
})(["all:initial;box-sizing:border-box;height:", ";min-width:0;padding:", ";padding-top:0.2em;", " ", " &,& + ", "{background-color:", ";border:solid ", ";border-radius:", ";border-width:", ";transition:0.1s ease-out;transition-property:border-color,background-color,color;}&{border-radius:", ";border-width:", ";}&::placeholder{color:", ";transition:color 0.1s ease-out;opacity:1;}&:invalid,&:invalid + ", "{border-color:", ";}&:invalid + ", "{color:", ";}&:focus,&:focus + ", "{border-color:", ";}&:hover,&:hover + ", "{background-color:", ";}&:disabled,&:disabled + ", "{background-color:", ";color:", ";}&:disabled::placeholder{color:", ";}", ""], tombac.space(5), _ref5 => {
  let {
    prepend
  } = _ref5;
  return tombac.space(0, 2, 0, prepend ? 6 : 2);
}, tombac.text({
  fontSize: 14
}), _ref6 => {
  let {
    append,
    prepend
  } = _ref6;
  return append !== undefined || prepend !== undefined ? css(["flex:1;width:0;"]) : css(["width:", ";"], tombac.space(20));
}, Append, tombac.color('neutral', 100), _ref7 => {
  let {
    highlighted,
    invalid,
    variant
  } = _ref7;
  return highlighted ? tombac.color('accent', 500) : invalid || variant === 'danger' ? tombac.color('danger', 500) : variant === 'alert' ? tombac.color('alert', 500) : tombac.color('neutral', 400);
}, tombac.unit(0, 7, 7, 0), tombac.unit(1, 1, 1, 0), _ref8 => {
  let {
    append
  } = _ref8;
  return append ? tombac.unit(7, 0, 0, 7) : tombac.unit(7);
}, _ref9 => {
  let {
    append
  } = _ref9;
  return append ? tombac.unit(1, 0, 1, 1) : tombac.unit(1);
}, tombac.color('neutral', 600), Append, tombac.color('danger', 500), Append, tombac.color('danger', 500), Append, tombac.color('accent', 500), Append, tombac.color('neutral', 200), Append, tombac.color('neutral', 300), tombac.alpha('neutral', 24), tombac.alpha('neutral', 24), propStyling);
const Prepend = styled.span.withConfig({
  displayName: "Input__Prepend"
})(["align-items:center;box-sizing:border-box;color:", ";cursor:", ";display:flex;height:", ";justify-content:center;left:0;padding-top:", ";position:absolute;top:0;width:", ";"], _ref10 => {
  let {
    disabled,
    invalid,
    variant
  } = _ref10;
  return disabled ? tombac.alpha('neutral', 24) : invalid || variant === 'danger' ? tombac.color('danger', 500) : variant === 'alert' ? tombac.color('alert', 600) : 'inherit';
}, _ref11 => {
  let {
    disabled
  } = _ref11;
  return disabled ? 'default' : 'auto';
}, tombac.space(5), _ref12 => {
  let {
    prepend
  } = _ref12;
  return typeof prepend === 'string' ? '0.2em' /* Fixes font alignment */ : undefined;
}, tombac.space(6));
export const Input = /*#__PURE__*/forwardRef((_ref13, ref) => {
  let {
    className,
    ...rest
  } = _ref13;
  const {
    append,
    disabled,
    invalid,
    prepend,
    variant
  } = rest;
  const componentClass = cx('TombacInput', className);
  if (append !== undefined || prepend !== undefined) {
    const [stylingProps, nonStylingProps] = extractStylingProps(rest);
    return /*#__PURE__*/React.createElement(Container, _extends({
      className: componentClass
    }, stylingProps), prepend && /*#__PURE__*/React.createElement(Prepend, {
      disabled,
      invalid,
      prepend,
      variant
    }, prepend), /*#__PURE__*/React.createElement(InputElement, _extends({}, nonStylingProps, {
      ref: ref
    })), append && /*#__PURE__*/React.createElement(Append, {
      append,
      disabled,
      invalid,
      variant
    }, append));
  } else {
    return /*#__PURE__*/React.createElement(InputElement, _extends({
      className: componentClass
    }, rest, {
      ref: ref
    }));
  }
});
//# sourceMappingURL=Input.js.map